<template>
  <div class="page">
    <TopNav
        activeLv1="report"
        activeLv2=""
        @nav="onNav"
        @sub="onSub"
    />

    <div class="wrap">
      <table class="tbl">
        <colgroup>
          <col width="5.66%" />
          <col width="9.43%" />
          <col width="18.87%" />
          <col width="9.43%" />
          <col width="9.43%" />
          <col width="9.43%" />
          <col width="9.43%" />
          <col width="9.43%" />
          <col width="9.43%" />
          <col width="9.43%" />
        </colgroup>
        <thead>
        <tr>
          <th>{{$t('report.No')}}</th>
          <th>{{$t('report.Date')}}</th>
          <th>{{$t('report.Remark')}}</th>
          <th>{{$t('report.Turnover')}}</th>
          <th>{{$t('report.ValidBet')}}</th>
          <th>{{$t('report.NetWL')}}</th>
          <th>{{$t('report.Comm')}}</th>
          <th>{{$t('report.Deposit')}}</th>
          <th>{{$t('report.Withdraw')}}</th>
          <th>{{$t('report.Balance')}}</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(r, i) in rows"
            :key="r.date"
            class="row">
        <td>{{ i + 1 }}</td>
          <td>{{ r.date }}</td>
          <td></td>
          <td class="num">
            <span
                class="link"
                @click.stop="onTurnoverClick(r)"
            >
              {{ fmt(r.turnover) }}
            </span>
          </td>
          <td class="num">{{ fmt(r.validBet) }}</td>
          <td class="num"
              :class="{ neg: r.netWL < 0, pos: r.netWL > 0 }">
            {{ fmt(r.netWL) }}
          </td>
          <td class="num"></td>
          <td class="num">{{ fmtFloat(r.deposit) }}</td>
          <td class="num">{{ fmtFloat(r.withdraw) }}</td>
          <td class="num">{{ fmtFloat(r.balance) }}</td>
        </tr>

        <tr v-if="!rows.length">
          <td colspan="10" class="empty">-</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import { getReportDailyApi } from "@/api/report";

export default {
  components: { TopNav },

  data() {
    return {
      rows: []
    };
  },

  mounted() {
    this.$updateViewport(1280);
    this.loadReport();
  },

  methods: {
    // ===== 顶部菜单 =====
    onNav(key) {
      if (key === "news") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lotto") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lottery") {
        this.$router.push("/lottery");
        return;
      }
      if (key === "report") {
        this.$router.push("/report");
        return;
      }
      if (key === "balance") {
        this.$router.push("/balance");
        return;
      }
      if (key === "changePassword") {
        this.$router.push("/change-password");
        return;
      }
      alert("Coming soon");
    },
    onSub() {},

    onTurnoverClick(row) {
      // 你现在的需求：点击 Turnover
      // 👉 本质就是“看当天所有下注明细”
      // 和你现在整行点击是同一个目标，但你可以区分来源

      console.log("Turnover clicked:", row);

      // 直接进当天详情页（推荐）
      this.$router.push(`/report/${row.date}`);

      // 如果你以后想做不同逻辑（比如弹窗），也可以在这里扩展
    },

    async loadReport() {
      try {
        const res = await getReportDailyApi();

        // ✅ 关键：兼容 http 是否 return data
        const d = res && res.data ? res.data : res;

        console.log("[report] raw res =", res);
        console.log("[report] data d =", d);

        this.rows = Array.isArray(d) ? d : [];
      } catch (e) {
        console.error("[report] loadReport error:", e);
        this.rows = [];
      }
    },

    fmt(v) {
      return Math.floor(Number(v || 0)).toLocaleString();
    },

    fmtFloat(v) {
      return Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    fmtDateOnly(val) {
      if (!val) return "";
      if (val.includes("-")) {
        let [y, m, day] = val.split("-");
        return `${day}/${m}/${y}`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.page { background:#fff; min-height:100vh; min-width: 1280px; }
.wrap { padding:10px; }

.tbl { 
  width: 100%; 
  border-collapse:collapse; 
  font-size:13px; 
  border: 1px solid #ddd;
  table-layout: fixed;
}
.tbl th {
  background:#3C5AA0; 
  color:#FFFFFF;
  border:1px solid #ddd;
  padding: 0;
  height: 25px;
  font-weight:900;
}
.tbl td {
  border:1px solid #ddd;
  padding: 0;
  height: 23px;
  text-align:center;
  color: #000000;
}
.row { cursor:default; background: #fff; }
.row:hover { background:#f0f7ff; }
.tbl td.num { text-align:right; padding-right:12px; font-weight: 600; }
.tbl td.neg { color:#FF0000 !important; font-weight:800; }
.tbl td.pos { color:#000000; font-weight:800; }
.empty { padding:30px; color:#777; font-size: 14px; }
.link {
  cursor: pointer;
  text-decoration: underline;
  color: #000000;
  font-weight: 700;
}

.link:hover {
  color: #2a4f9b;
}
</style>
